module.exports = __webpack_public_path__ + "img/trade_instructions.0e48b0fa.png";